import { ApiMetric } from "@incendium/api";
import { useMetricLabels } from "features/analytics/hooks/useMetricLabels";
import { groupMetricsByCategory } from "features/analytics/utils/utils";
import { useCallback } from "react";

export const useGroupMetricsByCategory = () => {
  const { metricLabels } = useMetricLabels();
  return useCallback(
    (metrics: ApiMetric[]) => {
      return groupMetricsByCategory(metrics, metricLabels);
    },
    [metricLabels]
  );
};
